<script>
import { shrinkString } from '../../helpers/filters';

export default {
  name: 'SalePoolDetails',
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    shrinkString,
  },
};
</script>

<template>
  <v-row class="align-stretch">
    <v-col sm="6" cols="12">
      <div class="upcoming-card main-block">
        <p class="label mb-7">{{ $t('upcoming.token-information') }}</p>
        <v-row class="upcoming-info">
          <v-col sm="6" xs="12">
            {{ $t('upcoming.name') }}
          </v-col>
          <v-col sm="6" xs="12" v-html="product.name">
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col sm="6" xs="12">
            {{ $t('upcoming.ticker') }}
          </v-col>
          <v-col sm="6" xs="12">
            {{ product.tokenTicker }}
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col cols="4">
            {{ $t('upcoming.address') }}
          </v-col>
          <v-col>
            <a
              :href="product.addressLink"
              target="_blank"
              :title="`${$t('upcoming.address')} link`"
              >{{ `${shrinkString(product.address, 18)}` }}</a
            >
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col sm="6" xs="12">
            {{ $t('upcoming.total-supply') }}
          </v-col>
          <v-col sm="6" xs="12">
            {{ product.totalSupply }}
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col sm="6" cols="12">
      <div class="upcoming-card main-block">
        <p class="label mb-7">{{ $t('upcoming.pool-information') }}</p>
        <v-row class="upcoming-info">
          <v-col sm="6" xs="12">
            {{ $t('upcoming.total-raise') }}
          </v-col>
          <v-col sm="6" xs="12">
            {{ product.totalRaise }}
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col>
            {{ $t('upcoming.total-amount') }}
          </v-col>
          <v-col cols="4">
            {{ product.totalOfferingAmount }}
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col sm="6" xs="12">
            {{ $t('upcoming.sale-token') }}
          </v-col>
          <v-col sm="6" xs="12">
            <a
              :href="product.paymentTokenLink"
              target="_blank"
              :title="`${$t('upcoming.sale-token')} link`"
            >
              {{ product.paymentToken }}
            </a>
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col sm="6" xs="12">
            {{ $t('upcoming.price') }}
          </v-col>
          <v-col sm="6" xs="12">
            {{ product.price }}
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col sm="8" cols="12" offset-sm="2">
      <div class="upcoming-card main-block">
        <p class="label mb-7">{{ $t('upcoming.campaign-details') }}</p>
        <v-row class="upcoming-info">
          <v-col sm="6" xs="12">
            {{ $t('upcoming.sale-date') }}
          </v-col>
          <v-col sm="6" xs="12">
            {{ product.date }}
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col cols="4">
            {{ $t('upcoming.vesting-info') }}
          </v-col>
          <v-col>
            {{ product.vestingInfo }}
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col sm="6" xs="12">
            {{ $t('upcoming.date-tge') }}
          </v-col>
          <v-col sm="6" xs="12">
            {{ product.dateTGE }}
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col cols="4">
            {{ $t('upcoming.distribution-details') }}
          </v-col>
          <v-col>
            {{ product.distributionInfo }}
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col>
            {{ $t('upcoming.sale-blockchain') }}
          </v-col>
          <v-col cols="4">
            {{ product.saleBlockchain }}
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col>
            {{ $t('upcoming.distribution-blockchain') }}
          </v-col>
          <v-col cols="4">
            {{ product.distributionBlockchain }}
          </v-col>
        </v-row>
        <v-row class="upcoming-info" v-if="product.saleType === 'SMPL'">
          <v-col>
            {{ $t('upcoming.participate-stake', { token: product.stakeToken.toUpperCase() }) }}
          </v-col>
          <v-col cols="4">
            {{ product.minimunStake }}
          </v-col>
        </v-row>
        <div v-else>
          <v-row class="upcoming-info" >
            <v-col>
              {{ $t('upcoming.min-stake', { token: product.stakeToken.toUpperCase() }) }}
            </v-col>
            <v-col cols="4">
              {{ product.minimunStake }}
            </v-col>
          </v-row>
          <v-row class="upcoming-info">
            <v-col>
              {{ $t('upcoming.max-stake', { token: product.stakeToken.toUpperCase() }) }}
            </v-col>
            <v-col cols="4">
              {{ product.maximumStake }}
            </v-col>
          </v-row>
        </div>
        <v-row class="upcoming-info">
          <v-col>
            {{ $t('upcoming.participants-limit') }}
          </v-col>
          <v-col cols="4">
            {{ product.participantsLimit }}
          </v-col>
        </v-row>
        <v-row class="upcoming-info">
          <v-col>
            {{ $t('upcoming.participants-restrictions') }}
          </v-col>
          <v-col cols="4">
            {{ product.participationRestrictions }}
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-row>
</template>

<style lang="scss"></style>
